<template>
  <v-navigation-drawer
    :value="isSidebarDataHeadActive"
    temporary
    touchless
    :right="!$vuetify.rtl"
    width="350"
    app
    @input="val => $emit('update:is-sidebar-data-head-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center">
        <h4 class="font-weight-semibold text-base">
          {{ $t('lbl.info') }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-sidebar-data-head-active', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text class="pt-5">
        <v-form v-if="header">
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="header.name"
                :label="$t('lbl.name')"
                hide-details
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex flex-wrap mt-10">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-btn
                  color="primary"
                  class="me-3"
                  block
                  @click="$emit('update:is-sidebar-data-head-active', false)"
                >
                  {{ $t('btn.continue') }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-btn
                  color="secondary"
                  outlined
                  block
                  @click="$emit('update:is-sidebar-data-head-active', false)"
                >
                  {{ $t('btn.cancele') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { mdiClose, mdiAccountCashOutline } from '@mdi/js'

export default {
  model: {
    prop: 'isSidebarDataHeadActive',
    event: 'update:is-sidebar-data-head-active',
  },
  props: {
    isSidebarDataHeadActive: {
      type: Boolean,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    posHead: {
      type: Number,
    },
    // eslint-disable-next-line vue/require-default-prop
    position: {
      type: String,
    },
  },
  data() {
    return {
      icons: {
        mdiClose,
        mdiAccountCashOutline,
      },
      head: {},
    }
  },
  computed: {
    ...mapState({
      seasting: state => state.app.seasting,
    }),
    header() {
      let item = {}
      if (this.position === 'left') {
        item = this.seasting.headersLeft[this.posHead]
      } else {
        item = this.seasting.headersRight[this.posHead]
      }

      return item
    },
  },
  methods: {
    ...mapMutations(['setCheckAll', 'updateItemCheck']),
  },
}
</script>
